import { makeStyles, tokens } from '@fluentui/react-components'

export const usePageNotFoundStyles = makeStyles({
  root: {
    boxSizing: 'border-box',
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: tokens.spacingVerticalXXXL,
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacingHorizontalS,
    marginBottom: tokens.spacingVerticalS,
  },
  errorIcon: {
    color: tokens.colorPaletteRedForeground1,
  },
  subText: {
    marginBottom: tokens.spacingVerticalXXL,
    color: tokens.colorNeutralForeground3,
    textAlign: 'center',
  },
})
